import type { Nullable } from '@ats/interfaces';
import type {
  AudioInputDevice,
  AudioVideoFacade,
  Logger,
  POSTLogger,
  VideoInputDevice,
} from 'amazon-chime-sdk-js';

export type AudioVideoValue = Nullable<AudioVideoFacade>;

export type Direction = 'up' | 'right' | 'down' | 'left';

export type DeviceType = {
  deviceId: string;
  label: string;
};

export type AudioInputContextType = {
  devices: DeviceType[];
  selectedDevice: AudioInputDevice | undefined;
};

export type AudioOutputContextType = {
  devices: DeviceType[];
  selectedDevice: Nullable<string>;
};

export type VideoInputContextType = {
  devices: DeviceType[];
  selectedDevice: VideoInputDevice | undefined;
};

export type LocalAudioOutputContextType = {
  isAudioOn: boolean;
  toggleAudio: () => void;
};

export type LocalVideoContextType = {
  tileId: null | number;
  isVideoEnabled: boolean;
  setIsVideoEnabled: (isEnabled: boolean) => void;
  hasReachedVideoLimit: boolean;
  setHasReachedVideoLimit: (hasReached: boolean) => void;
  toggleVideo: () => Promise<void>;
};

export type ContentShareControlContextType = {
  paused: boolean;
  toggleContentShare: (source?: string | MediaStream) => Promise<void>;
  togglePauseContentShare: () => void;
};

export enum MeetingStatus {
  Loading,
  Succeeded,
  Failed,
  Ended,
  JoinedFromAnotherDevice,
  Left,
  TerminalFailure,
  Reconnecting,
}

export type RosterAttendeeType = {
  chimeAttendeeId: string;
  externalUserId?: string;
  name?: string;
};

export type RosterType = {
  [attendeeId: string]: RosterAttendeeType;
};

export type DeviceLabelTrigger = () => Promise<MediaStream>;

export type MeetingConfig = {
  simulcastEnabled: boolean;
  logger: Logger;
  postLogger?: POSTLogger; // Keep track of POSTLogger to update meeting metadata while joining a meeting.
};
